import React, { Component, useRef, useMemo, useState, useEffect, forwardRef,useImperativeHandle } from "react";
// import Pdf from '../../../assets/pdf/cancelation_recshedule_policy.pdf';

const PriceDetailsMulti= forwardRef(({ selectedItinerary, isInternational, roomSelected, requestSlectedTotal, requestSlectedTCS, requestSlectedGST, requestSlectedPrice,  safetyPlan, isSafetyPlanSelected },ref)=> {

    const [selectedRoom, setSelectRoom] = useState(0);
    const [totalPrice, setTotalPrice] = useState(roomSelected[0].price.total);
    const [actualTotalPrice, setActualTotalPrice] = useState(0);
    const [gst, setGst] = useState(roomSelected[0].price.gst);
    const [tcs, setTcs] = useState(roomSelected[0].price.tcs == undefined ? null : roomSelected[0].price.tcs);
    const [insurance, setInsurance] = useState(roomSelected[0].price.insurance);
    const [portCharge, setPortCharge] = useState(roomSelected[0].price.port_charges);
    const [discount, setDiscount] = useState(roomSelected[0].price.discount);
    const [discountText, setDiscountText] = useState(roomSelected[0].price.discount_text);
    const [gratuvity, setGratuvity] = useState(roomSelected[0].price.gratuity);
    const [fuelSurcharge, setFuelSurcharge] = useState(roomSelected[0].price.fuel_surcharge);
    const [gratuityChecked, setGratuvityChecked] = useState(true)
    const [discountChecked, setDiscountChecked] = useState(true)

    var grandCabinTotal = 0;
    var actualGrandCabinTotal = 0;
    const totalAmount = roomSelected.map((data) => {
        grandCabinTotal = grandCabinTotal+data.price.total
        if(selectedItinerary.discount_pct > 0){
            actualGrandCabinTotal = actualGrandCabinTotal+data.price.actual_total
        }
    })

    useEffect(() => {
        if(selectedItinerary.discount_pct > 0){
            setActualTotalPrice(roomSelected[0].price.actual_total);
        }
    }, [])

    const Pdf = "https://images.cordeliacruises.com/static/cancellation_and_reschedule_policy.pdf"
    const selectRoom = (e) => {
        console.log("nik-log",roomSelected[e.target.value].price.gst,roomSelected)
        setSelectRoom(e.target.value)
        setTotalPrice(roomSelected[e.target.value].price.total)
        setGst(roomSelected[e.target.value].price.gst)
        setTcs(roomSelected[e.target.value].price.tcs == undefined ? null : roomSelected[e.target.value].price.tcs)
        setInsurance(roomSelected[e.target.value].price.insurance)
        setPortCharge(roomSelected[e.target.value].price.port_charges)
        setDiscount(roomSelected[e.target.value].price.discount)
        setGratuvity(roomSelected[e.target.value].price.gratuity)
        setFuelSurcharge(roomSelected[e.target.value].price.fuel_surcharge)
        setDiscountText(roomSelected[e.target.value].price.discount_text)

        if(selectedItinerary.discount_pct > 0){
            setActualTotalPrice(roomSelected[e.target.value].price.actual_total);
        }
    }



    useImperativeHandle(ref, () => ({

        defaultSelection(roomSelected){
            setSelectRoom(0)
            setTotalPrice(roomSelected[0].price.total)
            setGst(roomSelected[0].price.gst)
            setTcs(roomSelected[0].price.tcs == undefined ? null : roomSelected[0].price.tcs)
            setInsurance(roomSelected[0].price.insurance)
            setPortCharge(roomSelected[0].price.port_charges)
            setDiscount(roomSelected[0].price.discount)
            setGratuvity(roomSelected[0].price.gratuity)
            setFuelSurcharge(roomSelected[0].price.fuel_surcharge)
    }
    
      }));
    // const defaultSelection = () =>{
    //     console.log("nik-log",roomSelected)
    //     setSelectRoom(0)
    //     setTotalPrice(roomSelected[0][1].price.total)
    //     setGst(roomSelected[0][1].price.gst)
    //     setTcs(roomSelected[0][1].price.tcs == undefined ? null : roomSelected[0][1].price.tcs)
    //     setInsurance(roomSelected[0][1].price.insurance)
    //     setPortCharge(roomSelected[0][1].price.port_charges)
    //     setDiscount(roomSelected[0][1].price.discount)
    //     setGratuvity(roomSelected[0][1].price.gratuity)
    // }

    const handleGratuvity = (data) => {
        setGratuvityChecked(data)
        if(data) {
            setTotalPrice(totalPrice+gratuvity)
        } else {
            setTotalPrice(totalPrice-gratuvity)
        }

    }

    const handleDiscount = (data) => {
        setDiscountChecked(data)
        if(data) {
            setTotalPrice(totalPrice+(discount==null?0:discount))
        } else {
            setTotalPrice(totalPrice-(discount==null?0:discount))
        }

    }

    return(
        <>
           {roomSelected.map((key,i) => {
                return(
                    <div className="grid grid-cols-2">
                        <div className="flex">
                            <label className="pl-4">
                                <input 
                                    type="checkbox" 
                                    value={i} 
                                    checked={i==selectedRoom}
                                    onChange={(e) => selectRoom(e)} 
                                />
                                <span className="pl-1 text-sm">{key.name}</span>
                            </label>
                        </div>
                        <div className="flex w-full">
                            <p className="w-full text-right text-sm font-bold">&#x20B9;{Math.round(key.price.cabin_fare)}</p>
                        </div>
                    </div>)
            })}
            <div className="grid grid-cols-2 pt-2">
                <p className="pl-4 text-sm">Service Charges & Levies</p>
                <div className="flex w-full">
                    <p className="w-full text-right text-sm font-bold">&#x20B9;{Math.round(portCharge+gratuvity)}</p>
                </div>
            </div>
            <div className="grid grid-cols-2 pt-2">
                <p className="pl-4 text-sm">Fuel Surcharge</p>
                <div className="flex w-full">
                    <p className="w-full text-right text-sm font-bold">&#x20B9;{Math.round(fuelSurcharge)}</p>
                </div>
            </div>
            {/* <div className="grid grid-cols-2 pt-2">
                <p className="pl-4 text-sm">Port Charges</p>
                <div className="flex w-full">
                    <p className="w-full text-right text-sm font-bold">&#x20B9;{Math.round(portCharge)}</p>
                </div>
            </div>
            <div className="grid grid-cols-2 pt-2">
                <p className="pl-4 text-sm">Gratuity</p>
                <div className="flex w-full">
                    <p className="w-full text-right text-sm font-bold">&#x20B9;{Math.round(gratuvity)}</p>
                </div>
            </div> */}
            <div className="grid grid-cols-2 pt-2">
                <div>
                    <p class="ml-4 text-sm">Discount</p>
                    {discountText && <p class="ml-4 text-xs">{discountText}</p>}
                </div>
                <div className="flex w-full">
                    <p className="w-full text-right text-sm font-bold text-j-green"> - &#x20B9;{Math.round(discount==null?0:discount)}</p>
                </div>
            </div>
            <div className="grid grid-cols-2 pt-2">
                <p className="pl-4 text-sm">GST</p>
                <div className="flex w-full">
                    <p className="w-full text-right text-sm font-bold">&#x20B9;{Math.round(gst)}</p>
                </div>
            </div>
            {tcs != null && <div className="grid grid-cols-2 pt-2">
                <p className="pl-4 text-sm">TCS</p>
                <div className="flex w-full">
                    <p className="w-full text-right text-sm font-bold">&#x20B9;{Math.round(tcs)}</p>
                </div>
            </div>
            }
            {requestSlectedTotal > 0 && <div className="grid grid-cols-2 pt-2">
                <p className="pl-4 text-sm">Special Request</p>
                <div className="flex w-full">
                    <p className="w-full text-right text-sm font-bold">&#x20B9;{Math.round(requestSlectedPrice)}</p>
                </div>
            </div>
            }
             {requestSlectedTotal > 0 && <div className="grid grid-cols-2 pt-2">
                <p className="pl-4 text-sm">Special Request GST</p>
                <div className="flex w-full">
                    <p className="w-full text-right text-sm font-bold">&#x20B9;{Math.round(requestSlectedGST)}</p>
                </div>
            </div>
            }
            
            {/* <div className="grid grid-cols-2 pt-2">
                <p className="pl-4 text-sm">Insurance</p>
                <div className="flex w-full">
                    <p className="w-full text-right text-sm font-bold">&#x20B9;{Math.round(insurance)}</p>
                </div>
            </div> */}
             {isSafetyPlanSelected && <div className="grid grid-cols-2 pt-2">
                <p className="pl-4 text-sm">Safety Protection Plan</p>
                <div className="flex w-full">
                    <p className="w-full text-right text-sm font-bold">&#x20B9;{Math.round(parseInt(safetyPlan.plan_total)*roomSelected.length)}</p>
                </div>
            </div>
            }
            <div className="grid grid-cols-2 pt-4">
                <p className="pl-4 font-bold text-lg">Total</p>
                <div className="w-full">
                    {actualTotalPrice != 0 && <p className="w-full text-right text-sm line-through font-semibold">&#x20B9;{Math.round(actualTotalPrice)}</p>}
                    <p className="w-full text-right font-bold">&#x20B9;{Math.round(totalPrice)}</p>
                </div>
            </div>
            <div className="grid grid-cols-2 pt-4">
                <p className="pl-4 font-bold text-lg">Grand Total</p>
                <div className="w-full">
                    {actualGrandCabinTotal != 0 && <p className="w-full text-right text-sm line-through font-semibold">&#x20B9;{Math.round(actualGrandCabinTotal)}</p>}
                    <p className="w-full text-right font-bold">&#x20B9;{Math.round(isSafetyPlanSelected? grandCabinTotal+requestSlectedTotal+(parseInt(safetyPlan.plan_total)*roomSelected.length):grandCabinTotal+requestSlectedTotal)}</p>
                </div>
            </div>
            <div className="grid grid-cols-1 pt-4">
                <a className="pl-4 pr-4 text-sm cursor-pointer text-j-orange font-medium" href={Pdf} target="_blank">*Rescheduling and Cancellation policy</a>
            </div>
            <div className="grid grid-cols-1 pt-4">
                <a className="pl-4 pr-4 text-sm cursor-pointer text-j-orange font-medium" href="https://images.cordeliacruises.com/static/insurance_web_document.pdf" target="_blank">
                  *Insurance Policy Document
                  </a>
            </div>
            <div className="grid grid-cols-1 pt-4">
                <a className="pl-4 pr-4 text-sm cursor-pointer text-j-orange font-medium" href="https://images.cordeliacruises.com/static/OTHER_ADDITIONAL_CHARGES.pdf" target="_blank">
                  Other Additional Charges
                  </a>
            </div>
        </>
    )
})

export default PriceDetailsMulti;